<template>
  <div class="leftres">
    <div>
      <div :class=" showorhide ? 'inputtop' : 'inputtops' ">
        <div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
          <Commondropdownlist :event="item.event" @U8AccId="U8AccId" ref="U8quaRef" :key="index" :options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :lablewith="item.lablewith"></Commondropdownlist>
        </div>
        <div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
          <CommonBtngroup :chackboxtow="chackboxtow" :chackbox="chackbox" ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>
      <div class="TableBox" style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
        <U8quantityonhandreporttable @StockExport="StockExport" @onRowClick="onRowClick" :tableData="tableData" :total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></U8quantityonhandreporttable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="'../assets/icon/icon-errors.png'">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import Dialog from '../../../components/dialog.vue'
import U8quantityonhandreporttable from './components/U8quantityonhandreporttable.vue'
import utils from '../../../common/utils'
import {
  U8ReportU8CSReportList,
  HelperU8AccId,
  U8ReportU8CSReportExport,
  HelperU8Warehouse
} from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    Dialog,
    U8quantityonhandreporttable
  },
  data() {
    return {
      total: 1,
      pageindex: 1,
      pageSize: 20,
      tableData: [],
      dialogVisibles: false,
      showorhide: true,
      chackboxtow: true,
      chackbox: true,
      formdata: [
        {
          inputdata: '',
          title: '账套号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请选择',
          types: '',
          inputtype: 'select',
          width: '220px',
          options: [],
          lablewith: '120px',
          event: 'U8AccId'
        },
        {
          inputdata: '',
          title: '仓库',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请选择',
          types: '',
          inputtype: '',
          width: '220px',
          options: [],
          lablewith: '80px'
        },
        {
          inputdata: '',
          title: '产品型号/名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
          lablewith: '100px'
        },

        {
          inputdata: '',
          title: '近效期天数起始',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
          lablewith: '110px'
        },
        {
          inputdata: '',
          title: '批号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
          lablewith: '80px'
        },
        {
          inputdata: '',
          title: '近效期天数终止',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
          lablewith: '120px'
        },
      ],
      fromdatalist: [],
      from: {
        cAccId: "",
        cWhCode: "",
        Inventory: "",
        cBatch: "",
        IsAboveZero: null,
        IsShowExpire: null,
        ExpireDaysCount1: null,
        ExpireDaysCount2: null
      },
      qus: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false,
        submit: false,
        skip: false,//跳过
        reset: false, //重置
      },
    }
  },
  mounted() {
	  this.$message.warning("请填写搜索条件！");
    this.HelperU8AccId()
  },
  methods: {
    // 列表
    async u8ReportU8CSReportList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        data,
        code
      } = await U8ReportU8CSReportList({
        cAccId: this.from.cAccId || this.formdata[0].options[0].key,
        cWhCode: this.from.cWhCode,
        Inventory: this.from.Inventory,
        cBatch: this.from.cBatch,
        IsAboveZero: this.from.IsAboveZero,
        IsShowExpire: this.from.IsShowExpire,
        ExpireDaysCount1: this.from.ExpireDaysCount1,
        ExpireDaysCount2: this.from.ExpireDaysCount2,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      // //console.log(code, data.data)
      if (code == 0) {
        loading.close();
        this.total = data.Count
        if (data.data) {
          this.tableData = data.data
        }
      } else {
        loading.close();
      }
    },
    async u8ReportU8CSReportExport() {
      let resexprot = await U8ReportU8CSReportExport({
        cAccId: this.from.cAccId || this.formdata[0].options[0].key,
        cWhCode: this.from.cWhCode,
        Inventory: this.from.Inventory,
        cBatch: this.from.cBatch,
        IsAboveZero: this.from.IsAboveZero,
        IsShowExpire: this.from.IsShowExpire,
        ExpireDaysCount1: this.from.ExpireDaysCount1,
        ExpireDaysCount2: this.from.ExpireDaysCount2,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (resexprot) {
        let date = new Date()
        let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
        utils.downloadFile(resexprot, `U8_U9现存量导出${str}`, "xlsx")
      } else {
        // 返回json
        this.$message.warning('导出失败');
      }
    },
    StockExport() {
      this.u8ReportU8CSReportExport()
    },
    // 获取账套号下拉
    async HelperU8AccId() {
      let {
        code,
        data
      } = await HelperU8AccId({

      })
      if (code == 0) {
        try {
          this.formdata[0].options = []
          data.map((item, index) => {
            let obj = {
              key: item.Value,
              value: item.Text
            }
            this.formdata[0].options.push(obj)
            this.$refs.U8quaRef[0].modelvalue = this.formdata[0].options[0].key
            //this.u8ReportU8CSReportList()
            this.helperU8Warehouse(this.formdata[0].options[0].key)
          })

        } catch (error) {
        }
      }
    },
    // 仓库下拉
    async helperU8Warehouse(cAccId) {
      let {
        code,
        data
      } = await HelperU8Warehouse({

      }, cAccId)
      if (code == 0) {
        try {
          this.formdata[1].options = []
          data.map((item, index) => {
            let obj = {
              key: item.Value,
              value: item.Text
            }
            this.formdata[1].options.push(obj)
          })

        } catch (error) {
        }
      }
    },
    reset() {
      this.$refs.U8quaRef.map((item, index) => {
        if (index !== 0) {
          item.modelvalue = ''
        }
      })
      this.$refs.btngroup.checked = false
      this.$refs.btngroup.checkedTow = false
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      this.dialogVisibles = false
    },
    select() {
      for (let item of this.formdata) {
        this.fromdatalist.push(item.inputdata)
      }
      this.pageindex = 1
      // let reg = /^[0-9]+.?[0-9]*$/
      // //  return
     
      // if (!reg.test(this.$refs.U8quaRef[3].modelvalue) || !reg.test(this.$refs.U8quaRef[5].modelvalue)) {
      //   this.$notify.warning({
      //     title: '提示',
      //     message: '请输入数字'
      //   })
      //   return false
      // }
      try {
        this.from.cAccId = this.$refs.U8quaRef[0].modelvalue
        this.from.cWhCode = this.$refs.U8quaRef[1].modelvalue
        this.from.Inventory = this.$refs.U8quaRef[2].modelvalue
        this.from.cBatch = this.$refs.U8quaRef[4].modelvalue
        this.from.IsAboveZero = this.$refs.btngroup.checkeds ? 1 : 0
        this.from.IsShowExpire = this.$refs.btngroup.checkedTow ? 1 : 0
        this.from.ExpireDaysCount1 = this.$refs.U8quaRef[3].modelvalue
        this.from.ExpireDaysCount2 = this.$refs.U8quaRef[5].modelvalue
        this.u8ReportU8CSReportList()
      } catch (error) {
        if (!reg.test(this.$refs.U8quaRef[3].modelvalue) || !reg.test(this.$refs.U8quaRef[5].modelvalue)) {
          this.$notify.warning({
            title: '提示',
            message: '请输入数字'
          })
          return false
        }
        this.u8ReportU8CSReportList()
      }
    },
    hide() {
      this.showorhide = false
    },
    showclick() {
      this.showorhide = true
    },
    onRowClick(val) {
      //console.log(val, 'val');
    },
    U8AccId(e) {
      //console.log(e.modelvalue, 'e');
      this.helperU8Warehouse(e.modelvalue)
    },
    handleCurrentChange(pageindex) {
      this.pageindex = pageindex
      this.u8ReportU8CSReportList()
      //console.log(pageindex, 'pageindex')

    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.u8ReportU8CSReportList()
    },
  },
  watch: {
    showorhide: {
      handler(newVal, oldVal) {
        if (newVal == false) {
          this.chackboxtow = false
          this.chackbox = false
        } else {
          this.chackboxtow = true
          this.chackbox = true
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 50px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  transition: all 0.3s;
  overflow: hidden;
}
.inputtops {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 9px;
  padding-bottom: 64px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s;
}
.Btngroup {
  display: inline-block;
  float: right;
  margin-right: 0px;
  width: 300px;
  height: 50px;
  background-color: #ffffff;
  position: relative;
  bottom: 50px;
}
.Btngroups {
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 10px;
}
</style>